import React, { Component } from 'react';
import MuiAppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import SearchRounded from '@material-ui/icons/SearchRounded';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import Drawer from '@material-ui/core/Drawer';
import MenuIcon from '@material-ui/icons/Menu';
import CrossIcon from '@material-ui/icons/Close';
import PersonIcon from '@material-ui/icons/Person';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import initials from 'initials';
import { fade, InputBase, Theme, withStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import routes, { BASE_URL } from '../../../routes/index';
import { AuthenticationContextValue, withAuthenticationContext } from '../../../authentication';
import LicenseListSearched from '../../../views/License/LicenseListSearched';
import { ApplicationList } from '../../../store/modules/application/types';
import { EXPERIMENTAL, EXPERIMENTAL_ROUTES, FEATURE_ROUTES } from '../../../store/app.constants';
import { Person } from '../../../store/modules/person/types';
// Import our hooks

export type AppBarBaseProps = {
    classes: Record<
        'inputRoot' | 'resultContainer' | 'searchContainer' | 'search' | 'searchIcon' | 'crossIcon' | 'inputInput',
        string
    >;
    searchLicense: Function;
    licenseListSearchedCount: number;
    licenseListSearched: ApplicationList;
    history: any;
    siteTitle: string;
    featureFlags: string[];
    personListSearched: Person[];
};

type AppBarProps = AppBarBaseProps & {
    authenticationContext: AuthenticationContextValue;
};

type AppBarState = {
    drawerState: boolean;
    showSearchBar: boolean;
    showSearchResults: boolean;
    profileMenuAnchor: Element | undefined;
    searchString: string;
    highlightedIndex: number;
};

export const styles: any = (theme: Theme) => ({
    resultContainer: {
        position: 'absolute',
        maxHeight: 300,
        backgroundColor: fade(theme.palette.common.white, 1),
        'z-index': 103,
        width: 'calc(100% + 58px)',
        left: -29,
        marginTop: 10,
        boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px, rgba(9, 30, 66, 0.31) 0px 0px 1px',
        borderRadius: 4,
        overflow: 'auto',
    },
    searchContainer: {
        backgroundColor: fade(theme.palette.common.white, 1),
        marginRight: 20,
        borderRadius: 4,
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 1),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
        },
    },
    searchIcon: {
        color: 'black',
        paddingTop: 5,
        paddingLeft: 5,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 95,
        'z-index': 10,
        top: 3,
    },
    crossIcon: {
        color: 'black',
        paddingTop: 5,
        paddingRight: 5,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 95,
        'z-index': 10,
        top: 3,
    },
    inputRoot: {
        color: 'black',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 1),
        width: '100%',
        [theme.breakpoints.down('xl')]: {
            width: '60ch',
        },
        [theme.breakpoints.down('lg')]: {
            width: '60ch',
        },
        [theme.breakpoints.down('md')]: {
            width: '60ch',
        },
        [theme.breakpoints.down('sm')]: {
            width: '40ch',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
});

class AppBar extends Component<AppBarProps, AppBarState> {
    private searchInput: any = React.createRef();

    constructor(props: AppBarProps) {
        super(props);
        this.state = {
            drawerState: false,
            showSearchBar: false,
            showSearchResults: false,
            profileMenuAnchor: undefined,
            searchString: '',
            highlightedIndex: -1,
        };
    }

    toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        this.setState({ drawerState: open });
    };

    openProfileMenu = (evt: React.MouseEvent) => {
        this.setState({ profileMenuAnchor: evt.currentTarget });
    };

    handleHighlightedIndex = (keyCode: number) => {
        const { highlightedIndex } = this.state;
        const { licenseListSearched, licenseListSearchedCount, history } = this.props;
        switch (keyCode) {
            case 13:
                history.push(BASE_URL + `/license/${licenseListSearched[highlightedIndex].id}/detail`);

                this.setState({
                    drawerState: false,
                    showSearchBar: false,
                    showSearchResults: false,
                    searchString: '',
                    highlightedIndex: -1,
                });
                break;
            case 38:
                if (highlightedIndex > 0) {
                    this.setState({ highlightedIndex: highlightedIndex - 1 });
                } else {
                    this.setState({ highlightedIndex: licenseListSearchedCount - 1 });
                }
                break;
            case 40:
                if (highlightedIndex < licenseListSearchedCount - 1) {
                    this.setState({ highlightedIndex: highlightedIndex + 1 });
                } else {
                    this.setState({ highlightedIndex: 0 });
                }
                break;

            default:
                break;
        }
    };
    closeProfileMenu = () => {
        this.setState({ profileMenuAnchor: undefined });
    };

    resetSearchField = () => {
        this.setState({ searchString: '' });
        this.setState({ showSearchBar: false });
    };

    render() {
        const pathname = window.location.pathname;
        const { authenticationContext } = this.props;
        const { accountInfo } = authenticationContext;
        const {
            drawerState,
            profileMenuAnchor,
            showSearchBar,
            searchString,
            showSearchResults,
            highlightedIndex,
        } = this.state;
        const { classes, searchLicense, siteTitle, featureFlags } = this.props;

        return (
            <MuiAppBar className="app-header" position="sticky" color="primary">
                <Toolbar>
                    <Hidden xsDown={showSearchBar}>
                        <img alt="logo" className="icon" src={require('../../../assets/images/logo.png')} />
                        <Typography variant="h6" className="typography">
                            <Link to={`${BASE_URL}/licenses`}>{siteTitle}</Link>
                        </Typography>
                    </Hidden>
                    {(!showSearchBar && (
                        <>
                            <Hidden mdUp={true}>
                                <Box m={2}>
                                    <MenuIcon onClick={this.toggleDrawer(true)} />
                                </Box>
                                <Drawer anchor="right" open={drawerState} onClose={this.toggleDrawer(false)}>
                                    {routes.map((route) => {
                                        if (
                                            (!featureFlags.includes(EXPERIMENTAL) &&
                                                EXPERIMENTAL_ROUTES.includes(route.title)) ||
                                            (FEATURE_ROUTES.includes(route.title) &&
                                                !featureFlags.includes(route.title))
                                        ) {
                                            return null;
                                        } else {
                                            return (
                                                route.isLeftMenuItem && (
                                                    <ListItem button key={route.path}>
                                                        <Link to={route.path} onClick={this.toggleDrawer(false)}>
                                                            <ListItemText primary={route.title} />
                                                        </Link>
                                                    </ListItem>
                                                )
                                            );
                                        }
                                    })}
                                </Drawer>
                            </Hidden>
                            <Hidden smDown={true}>
                                <div className="nav-routes">
                                    {routes.map((route) => {
                                        if (
                                            (!featureFlags.includes(EXPERIMENTAL) &&
                                                EXPERIMENTAL_ROUTES.includes(route.title)) ||
                                            (FEATURE_ROUTES.includes(route.title) &&
                                                !featureFlags.includes(route.title))
                                        ) {
                                            return null;
                                        } else {
                                            return (
                                                route.isTopMenuItem && (
                                                    <Link
                                                        key={route.path}
                                                        to={route.path}
                                                        className={`nav-link ${
                                                            pathname === route.path ? 'active' : ''
                                                        }`}
                                                    >
                                                        {route.title}
                                                    </Link>
                                                )
                                            );
                                        }
                                    })}
                                </div>
                            </Hidden>
                            <div className="icon-container">
                                <IconButton
                                    color="inherit"
                                    onClick={() => {
                                        this.setState({ showSearchBar: true }, () => {
                                            this.searchInput.current.focus();
                                        });
                                    }}
                                >
                                    <SearchRounded fontSize="large" />
                                </IconButton>
                            </div>
                        </>
                    )) || (
                        <>
                            <Box
                                className={classes.searchContainer}
                                display="flex"
                                justifyContent="space-between"
                                aria-controls="license-search-menu"
                                aria-haspopup="true"
                            >
                                <div className={classes.searchIcon}>
                                    <SearchIcon />
                                </div>
                                <div className={classes.search}>
                                    <InputBase
                                        placeholder="Search by license, person, company"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        onKeyDown={(e) => {
                                            this.handleHighlightedIndex(e.keyCode);
                                        }}
                                        onFocus={() => {
                                            setTimeout(() => {
                                                this.setState({ showSearchResults: true });
                                            }, 110);
                                        }}
                                        onBlur={(e) => {
                                            if (e.target.value === '') {
                                                this.setState({ showSearchBar: false });
                                            }
                                            setTimeout(() => {
                                                this.setState({ showSearchResults: false });
                                            }, 300);
                                        }}
                                        value={searchString}
                                        onChange={(e) => {
                                            if (e.target.value.trim().length > 2) {
                                                searchLicense(e.target.value.trim());
                                            }
                                            this.setState({ searchString: e.target.value, showSearchResults: true });
                                        }}
                                        inputRef={this.searchInput}
                                        inputProps={{ 'aria-label': 'search' }}
                                    />
                                    {showSearchResults && searchString.trim().length > 2 && (
                                        <Box className={classes.resultContainer}>
                                            <LicenseListSearched
                                                highlightedIndex={highlightedIndex}
                                                resetSearchField={this.resetSearchField}
                                            />
                                        </Box>
                                    )}
                                </div>
                                {searchString.trim().length > 0 && (
                                    <div
                                        className={classes.crossIcon}
                                        onClick={() => {
                                            this.setState({ searchString: '' });
                                            this.searchInput.current.focus();
                                        }}
                                    >
                                        <CrossIcon />
                                    </div>
                                )}
                            </Box>
                        </>
                    )}
                    <Hidden xsDown={showSearchBar}>
                        <div className="icon-container">
                            <IconButton color="inherit" onClick={this.openProfileMenu}>
                                <PersonIcon fontSize="large" />
                            </IconButton>
                        </div>
                        <Popover
                            open={!!profileMenuAnchor}
                            onClose={this.closeProfileMenu}
                            anchorEl={profileMenuAnchor}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        >
                            <Card>
                                <CardHeader
                                    avatar={<Avatar>{initials(accountInfo.account.name)}</Avatar>}
                                    title={accountInfo.account.name}
                                />
                                <CardActions className="profile-actions-container">
                                    <Button size="small" color="primary" onClick={authenticationContext.logout}>
                                        Sign out
                                    </Button>
                                </CardActions>
                            </Card>
                        </Popover>
                    </Hidden>
                </Toolbar>
            </MuiAppBar>
        );
    }
}

export default withStyles(styles)(withAuthenticationContext<AppBarBaseProps>(AppBar));
